import { render, staticRenderFns } from "./Advancepb.vue?vue&type=template&id=e476b300&scoped=true&"
import script from "./Advancepb.vue?vue&type=script&lang=js&"
export * from "./Advancepb.vue?vue&type=script&lang=js&"
import style0 from "./Advancepb.vue?vue&type=style&index=0&id=e476b300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e476b300",
  null
  
)

export default component.exports